module.exports = __webpack_public_path__ + "img/works.6aba97fe.svg";